<template>
  <div class="box">
    <div class="shadow"></div>
    <div class="loginMsg">
      <p>登录</p>
      <input type="text" class="Input mt" placeholder="请输入你的雷电账号" v-model="account">
      <input type="password" class="Input mt" placeholder="请输入你的密码" v-model="password">
      <button class="btn0 mt" @click="handleLogin">登录</button>
      <div class="cancel" @click="handleCancle"></div>
    </div>
    <Bingo :title="title" v-if="open" @cancle="()=>{this.open=!this.open}"/>
  </div>
</template>

<script>
/* eslint-disable */
import qs from "qs";
import Bingo from "../common/Bingo";
import {Login} from '../../utils/config'
export default {
  components:{
    Bingo
  },
  data: () => ({
    account: "",
    password: "",
    title:'',
    open:false
  }),
  methods: {
    handleLogin() {
      if (!this.account || !this.password) {
        this.title="请输入完整的用户名和密码";
        this.open=true;
        return;
      }
      //设置秘钥
      let encry = this.$jsEncrypt;
      encry.setPublicKey(
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6uOzpfsQ1ScFPt6QPBNYFLIxm/yJC4/7UtLcbZAYeB2Wz85mzaNnaQuKb4nkGC1ltcRKukztWRRKA+gVBOt5cCAwEAAQ=="
      );
      let db = {
        account: encry.encrypt(this.account),
        password: encry.encrypt(this.password)
      };
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "post",
        transformRequest: [
          function(data) {
            // 对 data 进行任意转换处理
            return qs.stringify(data);
          }
        ],
        url:Login,
        data: db
      }).then(res => {
        let { data } = res;
        if (data.code == 0) {
          this.$emit("cancle", this.account);
        } else {
          this.title='账号或密码错误';
          this.open=true;
        }
      }).catch(err=>{
      })
    },
    handleCancle() {
      this.$emit("cancle");
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
}
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.loginMsg {
  position: absolute;
  border-radius: 10px;
  left: 50%;
  top: 29%;
  transform: translateX(-50%);
  width: 660px;
  text-align: center;
  font-size: 30px;
  background: #fff;
  z-index: 99999;
  padding: 35px 35px 0;
  .Input {
    width: 100%;
    height: 70px;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
    font-size: 20px;
    padding-left: 35px;
  }
  .mt {
    margin-top: 40px;
  }
  .mt1 {
    margin-top: 10px;
  }
  .btn0 {
    width: 100%;
    height: 70px;
    background: #d753f0;
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    color: #fff;
    border-radius: 10px;
  }
  .myGoods {
    margin-top: 40px;
    height: 495px;
    overflow-y: scroll;
    li {
      position: relative;
      margin-bottom: 10px;
      height: 92px;
      border-bottom: 2px solid #e1e1e1;
      text-align: left;
      .goods {
        font-size: 20px;
        margin-bottom: 12px;
      }
      .msg {
        font-size: 16px;
        margin-bottom: 14px;
      }
      .time {
        font-size: 12px;
        color: #868686;
      }
      .btnPosition {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
      }
    }
  }
  .text {
    font-size: 20px;
    padding-left: 35px;
    padding-top: 25px;
    width: 100%;
    border: 2px solid #c6c6c6;
    border-radius: 2px;
    height: 176px;
  }
}
.cancel {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  height: 48px;
  width: 48px;
  background:url('../assets/guanbi.png') no-repeat;
  background-size: 100% 100%;
}
</style>
